import { Box, Container, Typography, Stack, Link } from "@mui/material";
import FooterDetails from "./FooterDetails";

export default function Footer() {
  return (
    <div>
      <FooterDetails />
      <Box
        sx={{
          bgcolor: "#111",
          color: "white",
          py: 3,
          //   mt: 6,
        }}
      >
        <Container>
          <Stack direction="row" spacing={3} alignItems="center">
            <Typography variant="body2">
              © 2025 VR Builders & Promoters. All Rights Reserved.
            </Typography>

            <Link
              href="#"
              underline="hover"
              sx={{ color: "white", fontSize: 14 }}
            >
              Terms & Conditions
            </Link>

            <Link
              href="#"
              underline="hover"
              sx={{ color: "white", fontSize: 14 }}
            >
              Privacy Policy
            </Link>
          </Stack>
        </Container>
      </Box>
    </div>
  );
}
